import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const STATS = [
  { value: 1000, suffix: "+", label: "Happy Customers" },
  { value: 5000, suffix: "+", label: "Trips Completed" },
  { value: 50, suffix: "+", label: "Vehicles in Fleet" },
  { value: 24, suffix: "/7", label: "Customer Support" },
];

function Counter({ value, suffix, active }) {
  const [display, setDisplay] = useState(0);
  useEffect(() => {
    if (!active) return;
    const duration = 1600;
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(value * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [active, value]);
  return <span>{display}{suffix}</span>;
}

export default function Counters() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  return (
    <section ref={ref} className="relative bg-brand-blue text-white py-20 md:py-24 overflow-hidden" data-testid="counters-section">
      <div className="absolute inset-0 opacity-[0.08] bg-[radial-gradient(circle_at_20%_30%,white,transparent_50%)]" />
      <div className="relative max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-4">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="text-center md:text-left"
              data-testid={`counter-${i}`}
            >
              <div className="font-display text-6xl md:text-7xl font-black leading-none">
                <Counter value={s.value} suffix={s.suffix} active={inView} />
              </div>
              <div className="mt-3 text-[11px] tracking-[0.28em] uppercase font-semibold text-brand-orange">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
